import { useQuery } from '@tanstack/react-query';
import { client } from '../api/client';
import type { MSMERecord } from '../types';

export const RECORD_QUERY_KEY = 'record';

export function useRecord(id: string | null) {
  return useQuery<MSMERecord, Error>({
    queryKey: [RECORD_QUERY_KEY, id],
    queryFn: () => client.getRecord(id!),
    enabled: Boolean(id),
    staleTime: 60_000,
  });
}
